import { render } from "./HospitalInso.vue?vue&type=template&id=fd86de40&scoped=true"
import script from "./HospitalInso.vue?vue&type=script&lang=js"
export * from "./HospitalInso.vue?vue&type=script&lang=js"

import "./HospitalInso.vue?vue&type=style&index=0&id=fd86de40&scoped=true&lang=css"
import "./HospitalInso.vue?vue&type=style&index=1&id=fd86de40&lang=css"
import "../../style/HospitalInso.css?vue&type=style&index=2&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd86de40"]])

export default __exports__